import { render, staticRenderFns } from "./FeedbackStatByFailureType.vue?vue&type=template&id=fbd68026&"
import script from "./FeedbackStatByFailureType.vue?vue&type=script&lang=js&"
export * from "./FeedbackStatByFailureType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports